export default __webpack_public_path__ + "static/media/NotoSans-BoldItalic.fb774fd4.otf";